import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { EmitterService } from '../../services/emitter.service';
import { Router } from '@angular/router';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: 'app-abort-registration',
  templateUrl: './abort-registration.component.html',
  styleUrls: ['./abort-registration.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AbortRegistrationComponent implements OnInit, OnDestroy {

  canViewAbort = false;
  showTrustlyAbortText = false;
  isMobileSignUpUrl = false;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private emitterService: EmitterService,
    private router: Router,
  ) { 
    this.emitterService.abortStepOne$.pipe(takeUntil(this.destroy$)).subscribe(abortStepOneStatus => {
      this.canViewAbort = abortStepOneStatus;
    });
    this.emitterService.isTrustlySite$.pipe(takeUntil(this.destroy$)).subscribe(isTrustlySiteStatus => {
      this.showTrustlyAbortText = isTrustlySiteStatus;
    });
  }

  ngOnInit() {
    if(this.router.url.includes("mob_register")) {
      this.isMobileSignUpUrl = true;
    } else {
      this.isMobileSignUpUrl = false;
    }
  }

  gotoStepOne(){
    this.emitterService.broadcastAbortStepOne(false);
  }

  gotoHomePage(){
    this.emitterService.broadcastGoToHomePage(true);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
